import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  // border: 2px dashed ${(props) => props.theme.colors.border || '#ccc'};
  padding: 16px;
  background: ${(props) => props.theme.colors.white};
  position: relative;
  min-height: 400px;
`;

export const SectionChatPanel = styled(Section)`
  background: radial-gradient(77.51% 157.3% at 18.46% 91.07%, #f6f9ff 0%, #ffffff 80.17%);
`;

export const SidebarSection = styled(Section)`
  flex: 0 0 ${(props) => (props.$isCollapsed ? '43.8px' : '244px')};
  max-width: ${(props) => (props.$isCollapsed ? '43.8px' : '244px')};
  border-top: none !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: 0.5px solid ${(props) => props.theme.colors.clearGray};
  transition: flex-basis 0.2s ease-in-out, max-width 0.2s ease-in-out;
  padding: 0px !important;
`;

export const SectionLabel = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  background: ${(props) => props.theme.colors.text || '#000'};
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;
